import { useCallback } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { FLAT, GRADUATED, STAIRSTEP, VOLUME } from 'customer-data-objects/product/Pricing';
import FormattedPrice from '../Utilities/FormattedPrice';
import CustomQuantityInput from '../CustomQuantityInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function LineItemQuantityAndUnitPrice({
  id,
  currencyCode,
  price,
  pricing,
  effectiveUnitPrice,
  quantity,
  quantityMax,
  quantityMin,
  isEditable,
  error
}) {
  const Quantity = useCallback(() => isEditable ? /*#__PURE__*/_jsx(CustomQuantityInput, {
    quantity: quantity,
    id: id,
    min: quantityMin,
    max: quantityMax,
    error: error
  }) : /*#__PURE__*/_jsxs(Text, {
    "data-test-id": "line-item-quantity",
    color: "text-core-subtle",
    typography: "body-125",
    children: ["\xD7", quantity]
  }), [isEditable, quantity, quantityMin, quantityMax, error, id]);
  const UnitPrice = useCallback(() => {
    var _pricing$tierRanges$;
    // check if quantity is greater than first tier then we dont display the unit
    const quantityGreaterThanFirstTier = quantity > ((_pricing$tierRanges$ = pricing.tierRanges[0]) === null || _pricing$tierRanges$ === void 0 ? void 0 : _pricing$tierRanges$.end);
    switch (pricing.pricingModel) {
      // flat pricing is the standard one set price for all quantities
      case FLAT:
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "payments.perItem_jsx",
          options: {
            priceProps: {
              currencyCode,
              price
            }
          },
          elements: {
            FormattedPrice
          }
        });
      // volume pricing: the price decreases as the quantity increases, and all quantities have the same price
      case VOLUME:
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "payments.perItem_jsx",
          options: {
            priceProps: {
              currencyCode,
              price: effectiveUnitPrice
            }
          },
          elements: {
            FormattedPrice
          }
        });
      // graduated pricing: the price decreases as the quantity increases, and the price is different for each quantity
      case GRADUATED:
        return quantityGreaterThanFirstTier ? null : /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "payments.perItem_jsx",
          options: {
            priceProps: {
              currencyCode,
              price: effectiveUnitPrice
            }
          },
          elements: {
            FormattedPrice
          }
        });
      // price is always different per quantity so we never display the unit price
      case STAIRSTEP:
      default:
        return null;
    }
  }, [pricing, quantity, currencyCode, price, effectiveUnitPrice]);
  return /*#__PURE__*/_jsxs(Flex, {
    display: "flex",
    gap: "200",
    alignItems: "center",
    inlineSize: "100%",
    "data-test-id": "line-item-unit-price-wrapper",
    children: [/*#__PURE__*/_jsx(Flex, {
      children: /*#__PURE__*/_jsx(Quantity, {})
    }), /*#__PURE__*/_jsx(Flex, {
      flexShrink: 0,
      children: /*#__PURE__*/_jsx(Text, {
        as: "small",
        color: "text-core-subtle",
        "data-test-id": "line-item-tiered-unit-price",
        children: /*#__PURE__*/_jsx(UnitPrice, {})
      })
    })]
  });
}